import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Nillable, valueOrDefault } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { PublicBoxSortTypeSelectItemsProviderService } from '../../providers/public-box-sort-type-select-items-provider.service';
import { Observable } from 'rxjs';
import { PublicBoxSortType } from '../../enums/public-box-sort-type';
import { PublicSortPanelComponent } from '../public-sort-panel/public-sort-panel.component';

@Component({
  selector: 'app-public-box-sort-panel',
  imports: [CommonModule, PublicSortPanelComponent],
  templateUrl: './public-box-sort-panel.component.html',
  styleUrl: './public-box-sort-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxSortPanelComponent {
  /* prettier-ignore */
  private readonly provider = inject(PublicBoxSortTypeSelectItemsProviderService);

  public readonly sortTypeChange = output<Nillable<PublicBoxSortType>>();

  protected readonly selectItems$ = this.selectItemsSource();
  protected readonly valueOrDefault = valueOrDefault;

  private selectItemsSource(): Observable<SelectItem<PublicBoxSortType>[]> {
    return this.provider.selectItems();
  }
}
